import Carousel from './Carousel';

// export types
export type { CarouselProps } from './Carousel';

// export components
export { Carousel };
export default Carousel;
